// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__Nf_1w","title":"InfoRow_title__3Rw3p"};